import { localizedPath, PUBLIC_ROUTES } from '../config/seo';
import { useLanguage } from '../i18n';

function publicPath(path: string): string {
  const clean = path === '/' ? '/' : path.replace(/\/$/, '');
  return PUBLIC_ROUTES.includes(clean as (typeof PUBLIC_ROUTES)[number]) ? clean : '/';
}

export function Footer({ path }: { path: string }): JSX.Element {
  const { locale, localeOptions, t } = useLanguage();
  const currentPath = publicPath(path);

  return (
    <footer className="border-t border-[color:var(--line)] bg-[color:var(--surface)]">
      <div className="mx-auto flex max-w-7xl flex-col gap-5 px-4 py-8 text-sm text-[color:var(--muted)] sm:px-6 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="font-semibold text-[color:var(--text)]">LumaFrame</p>
          <p className="mt-1 max-w-[52ch]">{t('home.localBlurb')}</p>
        </div>

        <nav aria-label={t('nav.language')} className="flex flex-wrap items-center gap-2">
          {localeOptions.map((option) => {
            const isCurrent = option.value === locale;

            return (
              <a
                key={option.value}
                href={localizedPath(currentPath, option.value)}
                hrefLang={option.htmlLang}
                lang={option.htmlLang}
                aria-current={isCurrent ? 'page' : undefined}
                className={`rounded-md border px-3 py-2 text-sm font-medium transition hover:bg-[color:var(--panel-strong)] ${
                  isCurrent
                    ? 'border-[color:var(--text)] bg-[color:var(--text)] text-[color:var(--surface)]'
                    : 'border-[color:var(--line)] bg-[color:var(--panel)] text-[color:var(--text)]'
                }`}
              >
                {option.label}
              </a>
            );
          })}
        </nav>
      </div>
    </footer>
  );
}
